export default {
  add0f240cbd4914fd1aed8305872a3f4: 'Product price',
  '842adf4dcc244345b0c757e41a063bd5': 'Signing discount',
  '0c7bd83e46479eb03047f35d4a76284b': 'Signing price',
  '7494bddf5fbef99f30017752738b0f71':
    'You have experienced the content. Pay to unlock the full amount of content'
};
